import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import StoreDetailsComponent from './store/details';

const StoreDetails = () => {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    
    // Get query parameters
    const storeId = searchParams.get('id') || id;
    const moduleId = searchParams.get('module_id');
    const distance = searchParams.get('distance');
    const storeZoneId = searchParams.get('store_zone_id');

    return (
      <StoreDetailsComponent 
        id={storeId} 
        moduleId={moduleId}
        distance={distance}
        storeZoneId={storeZoneId}
      />
    );
};

export default StoreDetails;